// extracted by mini-css-extract-plugin
export default {"background_div":"Propertey_background_div__7djVy","label":"Propertey_label__K32Bx"};